
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import AdminDashboard from '@/components/community/admin/AdminDashboard';

const AdminPage = () => {
  const { user, isAdmin, isLoading, checkIsAdmin } = useAuth();
  const navigate = useNavigate();
  
  useEffect(() => {
    if (user) {
      checkIsAdmin();
    }
  }, [user, checkIsAdmin]);
  
  useEffect(() => {
    if (!isLoading) {
      if (!user) {
        navigate('/join');
        toast.error('Please log in to access the admin panel.');
      } else if (!isAdmin) {
        checkIsAdmin().then(isAdmin => {
          if (!isAdmin) {
            toast.error('You do not have admin access.');
            navigate('/community');
          }
        });
      }
    }
  }, [isLoading, user, isAdmin, navigate, checkIsAdmin]);
  
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-omoduduwa-terracotta border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-lg text-white">Verifying admin access...</p>
        </div>
      </div>
    );
  }
  
  if (!user) {
    return null;
  }

  if (!isAdmin) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center">
        <Card className="w-full max-w-md bg-white/95 backdrop-blur-sm shadow-xl">
          <CardHeader>
            <CardTitle className="text-center text-red-600">Admin Access Required</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-center mb-4 text-gray-700">You do not have permission to access the admin panel.</p>
            <div className="flex justify-center">
              <Button onClick={() => navigate('/community')} className="text-white">
                Return to Community
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <div className="bg-omoduduwa-indigo text-white py-12">
        <div className="container-custom">
          <h1 className="text-3xl md:text-4xl font-bold mb-2 text-white">
            YPL Admin Dashboard
          </h1>
          <p className="text-lg text-gray-200 max-w-2xl">
            Member management and approval system
          </p>
        </div>
      </div>
      
      <div className="container-custom py-8">
        <AdminDashboard />
      </div>
    </div>
  );
};

export default AdminPage;
